import { jsx } from '@emotion/core';
import css from '@styled-system/css';

var getCSS = function getCSS(props, theme) {
  if (!props.sx && !props.css) return undefined;
  var styles = css(props.sx)(theme);
  var raw = typeof props.css === 'function' ? props.css(theme) : props.css;
  return [styles, raw];
};

var parseProps = function parseProps(props, theme) {
  if (!props) return null;
  var next = {};

  for (var key in props) {
    if (key === 'sx') continue; //@ts-ignore

    next[key] = props[key];
  }

  var css = getCSS(props, theme); //@ts-ignore

  if (css) next.css = css;
  return next;
};

function makePragma(theme) {
  return function (type, props) {
    for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      children[_key - 2] = arguments[_key];
    }

    return jsx.apply(undefined, [type, parseProps(props, theme)].concat(children));
  };
}

export { makePragma };